(function () {
  'use strict';

  const LIMIT_NAMESPACE = 'data-sample-limit-data';

  function getLimitMap() {
    const element = document.querySelector(
      `script[${LIMIT_NAMESPACE}]`
    );

    if (!element) return {};

    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      console.warn('Unable to read sample limits', error);
      return {};
    }
  }

  function getVariantId(form) {
    const input = form.querySelector(
      '[name="id"], [name="variant_id"], input[data-product-variant]'
    );

    return input ? String(input.value) : null;
  }

  function getQuantity(form) {
    const input = form.querySelector('[name="quantity"]');
    const quantity = input ? parseInt(input.value, 10) : 1;

    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  async function getCartQuantity(variantId) {
    const response = await fetch('/cart.js', {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Unable to read the cart');
    }

    const cart = await response.json();

    return cart.items
      .filter((item) => String(item.variant_id) === String(variantId))
      .reduce((total, item) => total + item.quantity, 0);
  }

  async function validateAdd(form) {
    const variantId = getVariantId(form);
    const limitMap = getLimitMap();

    if (!variantId || !(variantId in limitMap)) {
      return true;
    }

    const limit = limitMap[variantId];

    // null means unlimited.
    if (limit === null || limit === '' || limit === undefined) {
      return true;
    }

    const requestedQuantity = getQuantity(form);
    const existingQuantity = await getCartQuantity(variantId);

    if (existingQuantity + requestedQuantity > Number(limit)) {
      const remaining = Math.max(Number(limit) - existingQuantity, 0);

      const message = remaining
        ? `You can add only ${remaining} more of this item.`
        : `You have reached the limit of ${limit} for this item.`;

      window.alert(message);
      return false;
    }

    return true;
  }

  document.addEventListener('submit', async function (event) {
    const form = event.target.closest('form[action*="/cart/add"]');

    if (!form || form.dataset.sampleLimitValidated === 'true') {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    form.dataset.sampleLimitValidated = 'true';

    try {
      const allowed = await validateAdd(form);

      if (allowed) {
        form.submit();
      }
    } catch (error) {
      console.error(error);

      // Fail closed so an unavailable cart request cannot bypass the limit.
      window.alert(
        'We could not verify the quantity limit. Please try again.'
      );
    } finally {
      delete form.dataset.sampleLimitValidated;
    }
  }, true);

const originalFetch = window.fetch;

window.fetch = async function (resource, options) {
  const url = typeof resource === 'string' ? resource : resource.url;

  if (
    url &&
    url.includes('/cart/add') &&
    options &&
    options.body
  ) {
    const limitMap = getLimitMap();

    try {
      let variantId;
      let quantity = 1;

      if (options.body instanceof FormData) {
        variantId = options.body.get('id');
        quantity = parseInt(options.body.get('quantity') || '1', 10);
      } else if (typeof options.body === 'string') {
        const body = JSON.parse(options.body);
        variantId = body.id || body.items?.[0]?.id;
        quantity = body.quantity || body.items?.[0]?.quantity || 1;
      }

      const limit = limitMap[String(variantId)];

      if (
        variantId &&
        limit !== undefined &&
        limit !== null &&
        Number(limit) >= 0
      ) {
        const existingQuantity = await getCartQuantity(variantId);

        if (existingQuantity + Number(quantity) > Number(limit)) {
          window.alert(`The maximum quantity for this item is ${limit}.`);
          return new Response(
            JSON.stringify({
              status: 422,
              message: `Maximum quantity allowed is ${limit}.`
            }),
            {
              status: 422,
              headers: {
                'Content-Type': 'application/json'
              }
            }
          );
        }
      }
    } catch (error) {
      console.error('Sample limit validation failed', error);
      return Promise.reject(error);
    }
  }

  return originalFetch.apply(this, arguments);
};

})();